__turbopack_context__.v({
  "circleWithDropShadow": "choose-your-plan-module__H2VpNq__circleWithDropShadow",
  "circleWithDropShadowAlt": "choose-your-plan-module__H2VpNq__circleWithDropShadowAlt",
  "circleWithDropShadowInner": "choose-your-plan-module__H2VpNq__circleWithDropShadowInner",
  "entryMethodAllPlansList": "choose-your-plan-module__H2VpNq__entryMethodAllPlansList",
  "entryMethodBadge": "choose-your-plan-module__H2VpNq__entryMethodBadge",
  "entryMethodCard": "choose-your-plan-module__H2VpNq__entryMethodCard",
  "entryMethodCards": "choose-your-plan-module__H2VpNq__entryMethodCards",
  "entryMethodContent": "choose-your-plan-module__H2VpNq__entryMethodContent",
  "entryMethodHeading": "choose-your-plan-module__H2VpNq__entryMethodHeading",
  "entryMethodList": "choose-your-plan-module__H2VpNq__entryMethodList",
  "entryMethodSticker": "choose-your-plan-module__H2VpNq__entryMethodSticker",
  "entryMethodStickerText": "choose-your-plan-module__H2VpNq__entryMethodStickerText",
  "entryMethodTabPage": "choose-your-plan-module__H2VpNq__entryMethodTabPage",
  "hero": "choose-your-plan-module__H2VpNq__hero",
  "heroImageDesktop": "choose-your-plan-module__H2VpNq__heroImageDesktop",
  "heroImageMobile": "choose-your-plan-module__H2VpNq__heroImageMobile",
  "heroTrustBulletContainer": "choose-your-plan-module__H2VpNq__heroTrustBulletContainer",
  "horizontalRule": "choose-your-plan-module__H2VpNq__horizontalRule",
  "prizePlatformBulletContainer": "choose-your-plan-module__H2VpNq__prizePlatformBulletContainer",
  "prizePlatformTitle": "choose-your-plan-module__H2VpNq__prizePlatformTitle",
  "trustBulletList": "choose-your-plan-module__H2VpNq__trustBulletList",
  "trustBulletListItem": "choose-your-plan-module__H2VpNq__trustBulletListItem",
  "trustBulletListQuarterOnMobile": "choose-your-plan-module__H2VpNq__trustBulletListQuarterOnMobile",
  "trustBulletListStackOnMobile": "choose-your-plan-module__H2VpNq__trustBulletListStackOnMobile",
});
